<template>
	<section class="Section">
			<div class="Container WhiteBox">
				<div class="BoxWide">
					<div class="Bookmark"><span>Scadenzario</span></div>
				</div>           
                <FiltroScadenzario @FiltraScadenzari ="filtraScadenzari($event)" @RimuoviFiltri="this.rimuoviFiltri"></FiltroScadenzario>
            </div>
            <div class="Container Counter">
                <GrigliaScadenzario :listaScadenzario="this.listaScadenzario"></GrigliaScadenzario>
            </div>                 
    </section>      

</template>
    

<script>

import FiltroScadenzario from "@/components/FiltroScadenzario.vue";
import GrigliaScadenzario from "@/components/GrigliaScadenzario.vue";
import {apiMixin, scadenzariMixin} from "/mixin.js";
import Scadenzario from "@/models/Scadenzario.model.js";

export default {
    name: "Scadenzario",
    mixins: [apiMixin, scadenzariMixin],
    data(){
        return {
            listaScadenzario: [],
            listaScadenzarioOriginale: []        
        }
    },
    components:{
        FiltroScadenzario,
        GrigliaScadenzario
    },
    mounted: function(){

        this.doApiCall("get", "scadenzario/GetScadenzario", this.$store.getters.getUtente.Token).then(

            (data) => {                
                if(data){
                    this.listaScadenzario = data.map(o => {
                        return Object.assign(new Scadenzario(), o)
                    });
                    let v = this.listaScadenzario;
                    this.listaScadenzarioOriginale = this.listaScadenzario;
                }
            }
        );
    }
}
</script>